<script setup>
const site = useState('site')
</script>

<template lang="pug">
div(v-if="site.banner")
  img(:src="site.banner" :alt="site.title").block.w-full.h-auto
div.web-banner.bg-cover.bg-no-repeat.bg-top.flex.flex-row.justify-center.items-center.py-20.text-xl(
  v-else
  :style="{ backgroundImage: `url('/banner-bg.jpg')`, minHeight: '500px' }"
)
  AppContainer(slim)
    Logo(:style="{ width: '565px', height: '88px', maxWidth: '100%' }")
    .h-8
    .stripe.bg-gradient-to-r.from-indigo-600.rounded-full.text-white.ml-24.my-4.py-2.px-8 主办方
      strong.inline-block.ml-4 上海市教育委员会
    .stripe.bg-gradient-to-r.from-indigo-600.rounded-full.text-white.ml-24.my-4.py-2.px-8 承办方
      strong.inline-block.ml-4 华东政法大学
    .h-8
    .hint.ml-32.text-indigo-800 举办时间：2023年5月
</template>
